var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"page__loader",attrs:{"persistent":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('PProgressSpinner',{attrs:{"strokeWidth":"5"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }